export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import type {CodeProps} from 'kpc/components/code';

const code = `function test() {
    console.log('hello world');
}`;
export default class extends Component {
    static template = template;

    static defaults() {
        return {
            value: code,
            theme: 'vs' as CodeProps['theme']
        }
    }
}